export { default } from './components/AssociatedLocations';
